import { useQuery } from '@tanstack/react-query';

import { LEAD_QUERY_KEYS } from '../utils/leadApi.constants';
import { mapLeadEvents } from '../mappers';
import { getLeadEvents } from '../services';

export function useGetLeadEvents({ enabled = true } = {}) {
  return useQuery({
    queryKey: LEAD_QUERY_KEYS.events,
    queryFn: async () => {
      const dto = await getLeadEvents();
      return mapLeadEvents(dto);
    },
    enabled,
    staleTime: 0,
    refetchOnMount: false,
  });
}
